import React, { useEffect, useState, useRef } from 'react';
import { Outlet, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Home, Coins, Shield, Leaf, FileText, Settings, Zap, ChevronDown, ChevronRight, User, LogOut, Bell, LayoutList, Wrench, Users, BookOpen, ScrollText, MessageSquare, Radio, Sliders, Check, CreditCard, PanelLeft, PanelLeftClose, MousePointerClick, Menu, X, AlertCircle, Network } from 'lucide-react';
const SERVICES = [{
  id: 's1',
  name: 'Customer Assistant',
  health: 'healthy' as const
}, {
  id: 's2',
  name: 'Smart Matcher',
  health: 'healthy' as const
}, {
  id: 's3',
  name: 'Content Moderator',
  health: 'warning' as const
}, {
  id: 's4',
  name: 'AI Tutor',
  health: 'healthy' as const
}];
function UserMenu() {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="relative" ref={menuRef} data-id="element-505" data-mp="1wjae2awe2f7v">
      <button onClick={() => setOpen(!open)} className="flex items-center gap-2.5 px-2 py-1.5 rounded-lg hover:bg-gray-100 transition-all" data-id="element-506" data-mp="1wj22cmc05fy9">
        <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face" alt="Marco Rossi" className="w-7 h-7 rounded-full object-cover border border-gray-200" data-id="element-507" data-mp="13ucxcc7tsqh8" />
        <div className="hidden md:flex flex-col items-start" data-id="element-508" data-mp="1duna5vpy7vvv">
          <span className="font-medium text-gray-700 text-[16px]" data-id="element-509" data-mp="2k9o0nlw7flv2">
            Marco Rossi
          </span>
        </div>
        <ChevronDown className={`w-3.5 h-3.5 text-gray-400 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} data-id="element-510" data-mp="2p6xvjh2d4pqa" />
      </button>

      {open && <div className="absolute top-full mt-2 right-0 w-[200px] bg-white border border-gray-200 rounded-xl overflow-hidden shadow-xl z-50" data-id="element-511" data-mp="1ulil4oe2g5ha">
          <div className="px-4 py-3 border-b border-gray-100" data-id="element-512" data-mp="29hi08izlf5vx">
            <p className="text-[13px] font-medium text-gray-900" data-id="element-513" data-mp="24iwz8hcioi6f">Marco Rossi</p>
            <p className="text-[11px] text-gray-500 mt-0.5" data-id="element-514" data-mp="1gtccdnd8t0rv">
              marco.rossi@siae.it
            </p>
          </div>
          <div className="py-1" data-id="element-515" data-mp="1bvk9jyb27u8w">
            <button className="w-full flex items-center gap-2.5 px-4 py-2.5 text-[13px] text-gray-600 hover:text-gray-900 hover:bg-gray-50 transition-all" data-id="element-516" data-mp="1bwc4d6wu1ny4">
              <User className="w-4 h-4" data-id="element-517" data-mp="1lsf5qajv1ik0" />
              Il mio profilo
            </button>
            <button className="w-full flex items-center gap-2.5 px-4 py-2.5 text-[13px] text-gray-600 hover:text-gray-900 hover:bg-gray-50 transition-all" data-id="element-518" data-mp="y2kzibu1qs8q">
              <Settings className="w-4 h-4" data-id="element-519" data-mp="t1x7bmu305cx" />
              Impostazioni
            </button>
          </div>
          <div className="border-t border-gray-100 py-1" data-id="element-520" data-mp="34pjw7i2u002x">
            <button className="w-full flex items-center gap-2.5 px-4 py-2.5 text-[13px] text-red-600 hover:bg-red-50 transition-all" data-id="element-521" data-mp="39iv65s2xwwz2">
              <LogOut className="w-4 h-4" data-id="element-522" data-mp="2urchl5w0lu43" />
              Esci
            </button>
          </div>
        </div>}
    </div>;
}
function ServiceSelector({
  selectedId,
  onSelect
}: {
  selectedId: string;
  onSelect: (id: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const selected = SERVICES.find(s => s.id === selectedId);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const healthDot = (health: string) => health === 'healthy' ? 'bg-[#00B4D8]' : health === 'warning' ? 'bg-amber-500' : 'bg-red-500';
  return <div className="relative mb-2" ref={ref} data-id="element-523" data-mp="2iipw42bcpat6">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-2.5 px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg hover:border-gray-300 transition-all" data-id="element-524" data-mp="2dkejxkxl2o7s">
        <div className={`w-2 h-2 rounded-full ${healthDot(selected?.health || 'healthy')} flex-shrink-0`} data-id="element-525" data-mp="369v9mattjr0b" />
        <span className="text-[13px] font-heading font-medium text-gray-700 truncate flex-1 text-left" data-id="element-526" data-mp="31b1uyf2sptyk">
          {selected?.name || 'Seleziona servizio'}
        </span>
        <ChevronDown className={`w-3.5 h-3.5 text-gray-400 flex-shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} data-id="element-527" data-mp="2saltfb5m4wwc" />
      </button>

      {open && <div className="absolute top-full mt-1.5 left-0 right-0 bg-white border border-gray-200 rounded-xl overflow-hidden shadow-xl z-50" data-id="element-528" data-mp="1gu5nc8fy7sm5">
          {SERVICES.map(service => <button key={service.id} onClick={() => {
        onSelect(service.id);
        setOpen(false);
      }} className={`w-full flex items-center gap-2.5 px-3 py-2.5 text-left transition-all ${service.id === selectedId ? 'bg-blue-50 text-[#2A3B5C]' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-529" data-mp="e7ym83r2e1x">
              <div className={`w-2 h-2 rounded-full ${healthDot(service.health)} flex-shrink-0`} data-id="element-530" data-mp="k277teio1d58" />
              <span className="text-[13px] font-heading font-medium truncate flex-1" data-id="element-531" data-mp="o3ketrxhvmdq">
                {service.name}
              </span>
              {service.id === selectedId && <Check className="w-3.5 h-3.5 text-[#00B4D8] flex-shrink-0" data-id="element-532" data-mp="2pvfef96h80fl" />}
            </button>)}
        </div>}
    </div>;
}
export function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const isCanvasPage = false;
  const [sidebarMode, setSidebarMode] = useState<'global' | 'service'>('global');
  const [selectedServiceId, setSelectedServiceId] = useState('s1');
  const [sidebarState, setSidebarState] = useState<'open' | 'closed' | 'hover'>('open');
  const [isHovering, setIsHovering] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [complianceSubmenuOpen, setComplianceSubmenuOpen] = useState(false);
  const effectivelyOpen = sidebarState === 'open' || sidebarState === 'hover' && isHovering;
  const sidebarWidth = effectivelyOpen ? 220 : 64;
  // Auto-open compliance submenu if on a compliance route
  useEffect(() => {
    if (location.pathname.startsWith('/compliance')) {
      setComplianceSubmenuOpen(true);
    }
  }, [location.pathname]);
  const cycleSidebarState = () => {
    setSidebarState(prev => {
      if (prev === 'open') return 'closed';
      if (prev === 'closed') return 'hover';
      return 'open';
    });
    setIsHovering(false);
  };
  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  // Auto-switch to service mode
  useEffect(() => {
    const match = location.pathname.match(/^\/servizio\/(\w+)/);
    if (match) {
      setSidebarMode('service');
      setSelectedServiceId(match[1]);
    }
  }, [location.pathname]);
  const handleServiceSelect = (id: string) => {
    setSelectedServiceId(id);
    navigate(`/servizio/${id}`);
  };
  return <div className="flex min-h-screen bg-[#F4F6F8]" data-id="element-533" data-mp="14e5wpojwisa3">
      {/* Mobile backdrop */}
      {isMobileMenuOpen && <div className="fixed inset-0 bg-black/60 z-30 lg:hidden" onClick={() => setIsMobileMenuOpen(false)} data-id="element-534" data-mp="plc8neqkd3tt" />}

      {/* Sidebar */}
      <aside className={`fixed left-0 top-0 bottom-0 bg-white border-r border-gray-200 flex flex-col transition-all duration-300 ease-in-out
          ${isMobileMenuOpen ? 'translate-x-0 z-40' : '-translate-x-full lg:translate-x-0 z-40'}
        `} style={{
      width: isMobileMenuOpen ? '280px' : `${sidebarWidth}px`
    }} onMouseEnter={() => {
      if (sidebarState === 'hover' && window.innerWidth >= 1024) setIsHovering(true);
    }} onMouseLeave={() => {
      if (sidebarState === 'hover' && window.innerWidth >= 1024) setIsHovering(false);
    }} data-id="element-535" data-mp="gn0fb4ybbrxo">
        {/* Logo */}
        <div className="h-20 px-3 pt-4 flex items-center justify-between overflow-hidden bg-white" data-id="element-536" data-mp="ddqrlwseu8rn">
          {effectivelyOpen || isMobileMenuOpen ? <img src="https://cdn.magicpatterns.com/uploads/ei3TPBS2kJEWcyNVT3MDLH/Nuovo_logo_SIAE.png" alt="SIAE" className="h-12 w-auto object-contain pl-[10px]" data-id="element-537" data-mp="8cl022ahkrjp" /> : <div className="w-full flex items-center justify-center shrink-0" data-id="element-538" data-mp="3qk0r0b9bzy2g">
              <img src="https://cdn.magicpatterns.com/uploads/w7MGdYYbFedFenJ3UpterB/siae-logo-png-transparent.png" alt="SIAE" className="w-11 h-11 object-contain" style={{
            filter: 'brightness(0) saturate(100%) invert(18%) sepia(30%) saturate(1000%) hue-rotate(185deg) brightness(95%) contrast(95%)'
          }} data-id="element-539" data-mp="262hzjiebbllr" />
            </div>}
          <button onClick={() => setIsMobileMenuOpen(false)} className="lg:hidden p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-all" data-id="element-540" data-mp="1mgby5ulqxcs1">
            <X className="w-5 h-5" data-id="element-541" data-mp="1wbdk6hkq5yqe" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-3 space-y-1 overflow-y-auto overflow-x-hidden custom-scrollbar transition-all duration-300 ease-in-out px-2" data-id="element-542" data-mp="214pzu27fev70">
          {sidebarMode === 'global' ? <>
              <NavLink to="/costs" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Overview" data-id="element-543" data-mp="18l16eq2st7rw">
                <Home className="w-4 h-4 flex-shrink-0" data-id="element-544" data-mp="sscwcgmmzhth" />
                <span className="text-[15px]" data-id="element-545" data-mp="xrg2k4ecru31">Overview</span>
              </NavLink>

              <div className="h-8 flex items-center overflow-hidden" data-id="element-546" data-mp="35up8rvyc40">
                {effectivelyOpen || isMobileMenuOpen ? <p className="px-3 text-[11px] font-heading font-medium text-gray-400 uppercase tracking-wider whitespace-nowrap" data-id="element-547" data-mp="51fr1mpcjir7">
                    Governance
                  </p> : <div className="h-px bg-gray-200 w-full mx-1" data-id="element-548" data-mp="et3oc48l3u0l" />}
              </div>

              <NavLink to="/cost-management" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Cost Management" data-id="element-549" data-mp="3dh99w875h6bf">
                <Coins className="w-4 h-4 flex-shrink-0" data-id="element-550" data-mp="1vlqrr5cy0hmc" />
                <span className="text-[15px]" data-id="element-551" data-mp="1ql2qzrywwmex">Cost Management</span>
              </NavLink>

              {/* Compliance with Submenu */}
              <div data-id="element-552" data-mp="1llgddhf6945l">
                <button onClick={() => {
              if (effectivelyOpen || isMobileMenuOpen) {
                setComplianceSubmenuOpen(!complianceSubmenuOpen);
              } else {
                navigate('/compliance/ai-act');
              }
            }} className={`nav-item w-full${location.pathname.startsWith('/compliance') ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Compliance" data-id="element-553" data-mp="1llzx93odu2m9">
                  <Shield className={`w-4 h-4 flex-shrink-0 ${location.pathname.startsWith('/compliance') ? 'text-[#00B4D8]' : ''}`} data-id="element-554" data-mp="sxu7u3mdvpg3" />
                  <span className="flex-1 text-left text-[15px]" data-id="element-555" data-mp="jcb8gko4g1t9">
                    Compliance
                  </span>
                  {(effectivelyOpen || isMobileMenuOpen) && <ChevronRight className={`w-3.5 h-3.5 transition-transform duration-200 ${complianceSubmenuOpen ? 'rotate-90' : ''} ${location.pathname.startsWith('/compliance') ? 'text-gray-800' : 'text-gray-400'}`} data-id="element-556" data-mp="ab3ci992vd2c" />}
                </button>

                {/* Submenu */}
                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${complianceSubmenuOpen && (effectivelyOpen || isMobileMenuOpen) ? 'max-h-[200px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-557" data-mp="t8o07d03w5ld">
                  <div className="ml-4 mt-1 space-y-1 border-l border-gray-200 pl-3" data-id="element-558" data-mp="1kxr1cjwp4zts">
                    <NavLink to="/compliance/ai-act" className={({
                  isActive
                }) => `flex items-center gap-2 px-3 py-2 text-[15px] font-heading font-medium rounded-lg transition-all ${isActive ? 'text-[#2A3B5C] bg-gray-100' : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'}`} data-id="element-559" data-mp="1pqtzz6gbyzgu">
                      {({
                    isActive
                  }) => <>
                          <AlertCircle className={`w-3.5 h-3.5 flex-shrink-0 ${isActive ? 'text-[#00B4D8]' : ''}`} data-id="element-560" data-mp="2rh1zdetw0t42" />
                          <span data-id="element-561" data-mp="2mkv2scndstys">AI Act</span>
                        </>}
                    </NavLink>
                    <NavLink to="/compliance/gdpr" className={({
                  isActive
                }) => `flex items-center gap-2 px-3 py-2 text-[15px] font-heading font-medium rounded-lg transition-all ${isActive ? 'text-[#2A3B5C] bg-gray-100' : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'}`} data-id="element-562" data-mp="2wg5571hoz3d3">
                      {({
                    isActive
                  }) => <>
                          <Shield className={`w-3.5 h-3.5 flex-shrink-0 ${isActive ? 'text-[#00B4D8]' : ''}`} data-id="element-563" data-mp="2mfx615epcasb" />
                          <span data-id="element-564" data-mp="2vfad5rfcsn9v">GDPR</span>
                        </>}
                    </NavLink>
                    <NavLink to="/compliance/audit" className={({
                  isActive
                }) => `flex items-center gap-2 px-3 py-2 text-[15px] font-heading font-medium rounded-lg transition-all ${isActive ? 'text-[#2A3B5C] bg-gray-100' : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'}`} data-id="element-565" data-mp="30dbykj094yoi">
                      {({
                    isActive
                  }) => <>
                          <FileText className={`w-3.5 h-3.5 flex-shrink-0 ${isActive ? 'text-[#00B4D8]' : ''}`} data-id="element-566" data-mp="3o47unsbqqg1k" />
                          <span data-id="element-567" data-mp="3t89zqvw8i93n">Audit Trail</span>
                        </>}
                    </NavLink>
                  </div>
                </div>
              </div>

              <NavLink to="/greenops" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="GreenOps" data-id="element-568" data-mp="3k7bxoj5cwbnp">
                <Leaf className="w-4 h-4 flex-shrink-0" data-id="element-569" data-mp="fvgeqakpc2xl" />
                <span className="text-[15px]" data-id="element-570" data-mp="b12r4uca703h">GreenOps</span>
              </NavLink>

              <NavLink to="/canvas" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="AI Map" data-id="element-571" data-mp="71lixt5gzoum">
                <Network className="w-4 h-4 flex-shrink-0" data-id="element-572" data-mp="2t03ilth57w03" />
                <span className="text-[15px]" data-id="element-573" data-mp="2t1wubn6m56ey">AI Map</span>
              </NavLink>

              <NavLink to="/reports" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Report" data-id="element-574" data-mp="2xydj8jlmzot3">
                <FileText className="w-4 h-4 flex-shrink-0" data-id="element-575" data-mp="2a8aq005zkcsw" />
                <span className="text-[15px]" data-id="element-576" data-mp="2f8f79sepxbk6">Report</span>
              </NavLink>

              <div className="h-8 flex items-center overflow-hidden" data-id="element-577" data-mp="2f62k90u3sb09">
                {effectivelyOpen || isMobileMenuOpen ? <p className="px-3 text-[11px] font-heading font-medium text-gray-400 uppercase tracking-wider whitespace-nowrap" data-id="element-578" data-mp="259psi8i4c785">
                    Configurazione
                  </p> : <div className="h-px bg-gray-200 w-full mx-1" data-id="element-579" data-mp="3j4lj0x8095j" />}
              </div>

              <NavLink to="/providers" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Provider" data-id="element-580" data-mp="1o1ylg6wmqhjo">
                <Zap className="w-4 h-4 flex-shrink-0" data-id="element-581" data-mp="1szhyj3hlcoa1" />
                <span className="text-[15px]" data-id="element-582" data-mp="1sxx5xjeu7fet">Provider</span>
              </NavLink>
              <NavLink to="/users" className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Fornitori & utenti" data-id="element-583" data-mp="26plexdtshnrk">
                <Users className="w-4 h-4 flex-shrink-0" data-id="element-584" data-mp="2br11jabm82c2" />
                <span className="text-[15px]" data-id="element-585" data-mp="mb1kl71r98lv">Fornitori</span>
              </NavLink>
            </> : <>
              {(effectivelyOpen || isMobileMenuOpen) && <ServiceSelector selectedId={selectedServiceId} onSelect={handleServiceSelect} data-id="element-586" data-mp="3royn3bs0h0qu" />}

              <div className="h-8 flex items-center overflow-hidden" data-id="element-587" data-mp="gb2iy1lhhkc">
                {effectivelyOpen || isMobileMenuOpen ? <p className="px-3 text-[11px] font-heading font-medium text-gray-400 uppercase tracking-wider whitespace-nowrap" data-id="element-588" data-mp="a7xnhm3qiv0a">
                    Servizio
                  </p> : <div className="h-px bg-gray-200 w-full mx-1" data-id="element-589" data-mp="3doo0ikxqi8bh" />}
              </div>

              <NavLink to={`/servizio/${selectedServiceId}`} end className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Overview" data-id="element-590" data-mp="3inhd8b575val">
                <LayoutList className="w-4 h-4 flex-shrink-0" data-id="element-591" data-mp="12vjpipxbdrl1" />
                <span className="text-[15px]" data-id="element-592" data-mp="2nenhdp1bwh7i">Overview</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/config`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Configurazione" data-id="element-593" data-mp="2ifu3hvi4qo6t">
                <Sliders className="w-4 h-4 flex-shrink-0" data-id="element-594" data-mp="23rfratytpndl" />
                <span className="text-[15px]" data-id="element-595" data-mp="23otlayrkzfxh">Configurazione</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/canali`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Canali" data-id="element-596" data-mp="1zo1aw26z34zm">
                <Radio className="w-4 h-4 flex-shrink-0" data-id="element-597" data-mp="3p26bz5kf4wsl" />
                <span className="text-[15px]" data-id="element-598" data-mp="3k67hd08hyijq">Canali</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/knowledge`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Knowledge" data-id="element-599" data-mp="fu4evwh9mlix">
                <BookOpen className="w-4 h-4 flex-shrink-0" data-id="element-600" data-mp="146xbzducu2p" />
                <span className="text-[15px]" data-id="element-601" data-mp="3t8hk2jhkrmw1">Knowledge</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/strumenti`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Strumenti" data-id="element-602" data-mp="3t6em9da6kpgr">
                <Wrench className="w-4 h-4 flex-shrink-0" data-id="element-603" data-mp="1hiyhxq4qwx1g" />
                <span className="text-[15px]" data-id="element-604" data-mp="1hif5goxv70ut">Strumenti</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/istruzioni`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Istruzioni" data-id="element-605" data-mp="1ckn3t37f40df">
                <MessageSquare className="w-4 h-4 flex-shrink-0" data-id="element-606" data-mp="1tviw7eyi72fs" />
                <span className="text-[15px]" data-id="element-607" data-mp="1yr7qp3vo1t58">Istruzioni</span>
              </NavLink>

              <div className="h-8 flex items-center overflow-hidden" data-id="element-608" data-mp="123bioneao65m">
                {effectivelyOpen || isMobileMenuOpen ? <p className="px-3 text-[11px] font-heading font-medium text-gray-400 uppercase tracking-wider whitespace-nowrap" data-id="element-609" data-mp="16456zhvnfmz1">
                    Analisi
                  </p> : <div className="h-px bg-gray-200 w-full mx-1" data-id="element-610" data-mp="1g3cfnrrfutft" />}
              </div>

              <NavLink to={`/servizio/${selectedServiceId}/log`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Log" data-id="element-611" data-mp="2mk7ruygsifk5">
                <ScrollText className="w-4 h-4 flex-shrink-0" data-id="element-612" data-mp="1wwc2ppnlz8cl" />
                <span className="text-[15px]" data-id="element-613" data-mp="2bpxgwurry2br">Log</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/costi`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Costi" data-id="element-614" data-mp="26rvxu9ucm30a">
                <CreditCard className="w-4 h-4 flex-shrink-0" data-id="element-615" data-mp="1stfosc90k0ez" />
                <span className="text-[15px]" data-id="element-616" data-mp="1o1xpdsmn27w4">Costi</span>
              </NavLink>
              <NavLink to={`/servizio/${selectedServiceId}/compliance`} className={({
            isActive
          }) => `nav-item${isActive ? ' active' : ''}${!effectivelyOpen && !isMobileMenuOpen ? ' collapsed' : ''}`} title="Compliance" data-id="element-617" data-mp="1nztc4k2unwj6">
                <Shield className="w-4 h-4 flex-shrink-0" data-id="element-618" data-mp="3bqsiejyb28vw" />
                <span className="text-[15px]" data-id="element-619" data-mp="3bsddqbsg1vut">Compliance</span>
              </NavLink>
            </>}
        </nav>

        {/* Bottom toggle (desktop only) */}
        <div className="hidden lg:block p-3 border-t border-gray-200" data-id="element-620" data-mp="322akqblbohwh">
          <button onClick={cycleSidebarState} className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-lg hover:bg-gray-50 transition-all group" title={sidebarState === 'open' ? 'Chiudi sidebar' : sidebarState === 'closed' ? 'Sidebar su hover' : 'Apri sidebar'} data-id="element-621" data-mp="3pr3bltn37zk8">
            <div className="flex-shrink-0" data-id="element-622" data-mp="25aqhmriuy0g1">
              {sidebarState === 'open' && <PanelLeft className="w-4 h-4 text-gray-500 group-hover:text-gray-900" data-id="element-623" data-mp="29d3e0pbpsm05" />}
              {sidebarState === 'closed' && <PanelLeftClose className="w-4 h-4 text-gray-500 group-hover:text-gray-900" data-id="element-624" data-mp="2pl1818sevg0h" />}
              {sidebarState === 'hover' && <MousePointerClick className="w-4 h-4 text-gray-500 group-hover:text-gray-900" data-id="element-625" data-mp="2ft57zs6rlftm" />}
            </div>
            <div className="flex items-center gap-2 flex-1 min-w-0 overflow-hidden whitespace-nowrap" data-id="element-626" data-mp="2awerj3r1si7o">
              <span className="text-[12px] font-heading font-medium text-gray-500 group-hover:text-gray-900 truncate" data-id="element-627" data-mp="38hswrxqq2nbx">
                {sidebarState === 'open' ? 'Aperta' : sidebarState === 'closed' ? 'Chiusa' : 'Hover'}
              </span>
              <div className="flex items-center gap-1 ml-auto flex-shrink-0" data-id="element-628" data-mp="2ul5myudo82ol">
                <div className={`w-1.5 h-1.5 rounded-full transition-all ${sidebarState === 'open' ? 'bg-[#00B4D8]' : 'bg-gray-300'}`} data-id="element-629" data-mp="1n6kf2nan4vny" />
                <div className={`w-1.5 h-1.5 rounded-full transition-all ${sidebarState === 'closed' ? 'bg-[#00B4D8]' : 'bg-gray-300'}`} data-id="element-630" data-mp="3us0zxvven60i" />
                <div className={`w-1.5 h-1.5 rounded-full transition-all ${sidebarState === 'hover' ? 'bg-[#00B4D8]' : 'bg-gray-300'}`} data-id="element-631" data-mp="7mjrv7ip2a8x" />
              </div>
            </div>
          </button>
        </div>
      </aside>

      {/* Top Bar */}
      {!isCanvasPage && <header className="fixed top-0 right-0 left-0 lg:left-[var(--sidebar-width)] h-14 bg-white/95 backdrop-blur-md border-b border-gray-200 z-30 flex items-center justify-between px-4 lg:px-6 transition-all duration-300 ease-in-out shadow-sm" style={{
      '--sidebar-width': `${sidebarWidth}px`
    } as React.CSSProperties} data-id="element-632" data-mp="maodokd1n1vx">
          <button onClick={() => setIsMobileMenuOpen(true)} className="lg:hidden p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-all" data-id="element-633" data-mp="2x2pkx6v1llp1">
            <Menu className="w-5 h-5" data-id="element-634" data-mp="3vflb6fjvde6o" />
          </button>

          <div className="hidden lg:block" data-id="element-635" data-mp="3vh4wwloaohfu" />

          <div className="flex items-center gap-3" data-id="element-636" data-mp="d9p5ycpg9ax3">
            <button className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-500 hover:text-gray-900 hover:bg-gray-100 transition-all relative" data-id="element-637" data-mp="d7cf1a1prq7w">
              <Bell className="w-4 h-4" data-id="element-638" data-mp="n6bq0z9ybxy2" />
              <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full bg-red-500" data-id="element-639" data-mp="n5a1bs00jcxv" />
            </button>
            <div className="w-px h-6 bg-gray-200" data-id="element-640" data-mp="vzoripm307vr" />
            <UserMenu data-id="element-641" data-mp="vzf150x4jypj" />
          </div>
        </header>}

      {/* Main Content */}
      <main className={`flex-1 min-h-screen transition-all duration-300 ease-in-out ml-0 lg:ml-[var(--sidebar-width)] ${!isCanvasPage ? 'pt-14' : ''}`} style={{
      '--sidebar-width': `${sidebarWidth}px`
    } as React.CSSProperties} data-id="element-642" data-mp="rzmlk49bcsao">
        <Outlet data-id="element-643" data-mp="1km4kcpt5qu0n" />
      </main>
    </div>;
}